<template>
  <div class="overflow: auto">
    <div
      style="
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 30px;
        margin-bottom: 50px;
      "
    >
      <Icon
        @click="pageTurning('subtract')"
        style="font-size: 40px; margin-right: 15px; cursor: pointer"
        type="ios-arrow-back"
      />
      <DatePicker
        @on-change="getTime"
        v-model="startTime"
        type="date"
        format="yyyy-MM-dd"
        placeholder="Select date"
        size="large"
        style="width: 200px"
      />
      <Icon
        @click="pageTurning('add')"
        style="font-size: 40px; margin-left: 15px; cursor: pointer"
        type="ios-arrow-forward"
      />
    </div>

    <Table
      style="font-size: 20px"
      :content="self"
      border
      stripe
      :columns="columns"
      :data="data"
    >
      <template slot-scope="{ row, index }" slot="name">
        <Input
          v-if="upData.id == row.id"
          v-model="upData.name"
          style="width: 200px"
        />
        <div v-else>
          {{ row.name }}
        </div>
      </template>
      <template slot-scope="{ row, index }" slot="updateTime">
        <DatePicker
          v-if="upData.id == row.id"
          v-model="upData.updateTime1"
          type="date"
          format="yyyy-MM-dd"
          size="large"
          style="width: 200px"
        />
        <div v-else>
          {{ row.updateTime }}
        </div>
      </template>
      <template slot-scope="{ row, index }" slot="upUpdateQuantity">
        <Input
          v-if="upData.id == row.id"
          v-model="upData.upUpdateQuantity"
          style="width: 200px"
        />
        <div v-else>
          {{ row.upUpdateQuantity }}
        </div>
      </template>
      <template slot-scope="{ row, index }" slot="settlementQuantity">
        <Input
          v-if="upData.id == row.id"
          v-model="upData.settlementQuantity"
          style="width: 200px"
        />
        <div v-else>
          {{ row.settlementQuantity }}
        </div>
      </template>
      <template slot-scope="{ row, index }" slot="remark">
        <Input
          v-if="upData.id == row.id"
          v-model="upData.remark"
          style="width: 200px"
        />
        <div v-else>
          {{ row.remark }}
        </div>
      </template>
      <template slot-scope="{ row, index }" slot="config">
        <Button
          v-if="time && row.id"
          @click="
            upData = row;
            reminder1 = true;
          "
          style="
            background: #1e88e5;
            border-color: #1e88e5;
            font-size: 14px;
            padding: 4px 10px;
          "
          type="error"
          size="small"
          >删除</Button
        >
        <Button
          v-if="time && upData.id != row.id"
          @click="config(row)"
          style="
            background: #1e88e5;
            border-color: #1e88e5;
            font-size: 14px;
            padding: 4px 10px;
            margin-left: 15px;
          "
          type="error"
          size="small"
          >修改</Button
        >
        <Button
          v-if="time && upData.id == row.id"
          @click="settleAccounts()"
          style="
            background: #1e88e5;
            border-color: #1e88e5;
            font-size: 14px;
            margin-left: 15px;
            padding: 4px 10px;
          "
          type="error"
          size="small"
          >保存</Button
        >
      </template>
    </Table>

    <!-- reminder1 = true; -->
    <Button
      v-if="time"
      @click="
        title = '新增';
        upData = {};
        addData();
      "
      style="
        background: #1e88e5;
        border-color: #1e88e5;
        font-size: 14px;
        padding: 4px 10px;
        float: right;
        margin-top: 30px;
      "
      type="error"
      size="small"
      >新增</Button
    >

    <Modal
      @on-ok="InformationInvalid"
      @on-cancel="upData = {}"
      width="500"
      v-model="reminder1"
      title="删除"
      >删除
    </Modal>
  </div>
</template>

<script>
import { api } from "../biz/api";
export default {
  name: "DataRecording",
  data() {
    return {
      self: this,
      reminder1: false,
      upData: {},
      title: "",
      startTime: this.getTime1(new Date()),
      time: true,
      data: [],
      columns: [
        {
          title: "银行名称",
          align: "center",
          slot: "name",
        },
        {
          title: "更新日期",
          align: "center",
          slot: "updateTime",
        },
        {
          title: "上游更新数量",
          align: "center",
          slot: "upUpdateQuantity",
        },
        {
          title: "结算数量",
          align: "center",
          slot: "settlementQuantity",
        },
        {
          title: "备注",
          align: "center",
          slot: "remark",
        },

        {
          title: "操作",
          align: "center",
          slot: "config",
          fixed: "right",
        },
      ],
    };
  },
  mounted: function () {
    this.startTime = this.getTime1(this.startTime);
    this.getData(this.startTime);
  },

  methods: {
    addData() {
      if (this.data.length == 0 || this.data[this.data.length - 1].id) {
        this.data.push({ updateTime1: this.getTime1(new Date()) });
      }
    },

    config(row) {
      this.upData = row;
      this.getData(this.startTime);
    },
    InformationInvalid() {
      api.DataRecordDel(this.upData.id).then((res) => {
        if (res.body.status) {
          this.$Message.info(res.body.message);
        }
        this.getData(this.startTime);
      });
    },
    settleAccounts() {
      if (this.upData.id) {
        if (this.upData.updateTime1) {
          this.upData.updateTime = this.getTime1(this.upData.updateTime1);
        } else {
          this.upData.updateTime = "";
        }
        api.DataRecordEdit(this.upData).then((res) => {
          if (res.body.status) {
            this.$Message.info(res.body.message);
          }
          this.startTime = this.getTime1(this.startTime);
          this.getData(this.startTime);
          this.upData = {};
        });
      } else {
        if (this.upData.updateTime1) {
          this.upData.updateTime = this.getTime1(this.upData.updateTime1);
        } else {
          this.upData.updateTime = "";
        }

        api.DataRecordAdd(this.upData).then((res) => {
          if (res.body.status) {
            this.$Message.info(res.body.message);
          }
          this.startTime = this.getTime1(this.startTime);
          this.getData(this.startTime);
          this.upData = {};
        });
      }
    },
    getData(data) {
      //   if (!data) {
      //     data = this.getTime1(this.startTime);
      //   }
      api.DataRecordList(data).then((res) => {
        this.data = res.body.data;
        this.data.forEach((element) => {
          element.updateTime1 = element.updateTime;
        });

        if (this.getTime1(this.startTime) == this.getTime1(new Date())) {
          this.time = true;
        } else {
          this.time = false;
        }
      });
    },
    pageTurning(type) {
      if (type == "subtract") {
        this.startTime = new Date(
          new Date(this.startTime).getTime() - 86400000
        );
      } else if (type == "add") {
        this.startTime = new Date(
          new Date(this.startTime).getTime() + 86400000
        );
      }
      this.startTime = this.getTime1(this.startTime);
      this.getData(this.startTime);
    },
    getTime1(date) {
      let y = new Date(date).getFullYear(); //年
      let m = new Date(date).getMonth() + 1; //月，月是从0开始的所以+1
      let d = new Date(date).getDate(); //日
      m = m < 10 ? "0" + m : m; //小于10补0
      d = d < 10 ? "0" + d : d; //小于10补0
      return y + "-" + m + "-" + d; //返回时间形式yyyy-mm-dd
    },
    getTime(data) {
      if (data) {
        this.startTime = data;
        this.getData(this.startTime);
      }
    },
  },
};
</script>

<style scoped lang = 'less'>
</style>